import { CerPromptService } from "@cer/cer-ui/cer-ui-prompt.service";
import { CerDataImportFile, IDataImportFileReader } from "./cer-data-import-types";

export class CerClipboardPasteFileReader {

  public static async readFromClipboard(files: FileList, reader: IDataImportFileReader, mimeTypeFilter: string[], ui: CerPromptService): Promise<CerDataImportFile[]> {
    const pasteFiles: CerDataImportFile[] = [];
    if (files?.length > 0) {

      for (var i = 0; i < files.length; i++) {
        const file = files.item(i);
        var pasteFile: CerDataImportFile = {
          name: file.name,
          type: file.type,
          size: file.size,
          lastModified: new Date(file.lastModified),
          status: 'error',
          statusText: 'Ikke læst'
        };

        ui.toast(`Henter fil '${pasteFile?.name}'`);
        try {
          const arrayBuffer = await file.arrayBuffer();
          if (file.type?.length > 0 && (mimeTypeFilter == null || mimeTypeFilter.includes(file.type))) {
            if (arrayBuffer.byteLength > 0) {
              pasteFile = await reader.read(arrayBuffer, pasteFile);
            }
            else {
              pasteFile.statusText = 'Filen er tom';
            }
          }
          else {
            pasteFile.statusText = 'Type er ikke tilladt';
          }
        }
        catch (e) {
          pasteFile.statusText = e.toString();
        }
        pasteFiles.push(pasteFile);
      }
    }
    return pasteFiles;
  }
}
